import { useState } from "react";
import Link from "next/link";
import { IconExclamationCircle } from "@tabler/icons-react";

import { isNotEmptyArray } from "@chef/utils/array";
import { Button, Card } from "@chef/components";
import { BRAND_PATHS } from "@chef/constants";
import { Modal } from "@chef/smart-components";

import { FloatingBar } from "./FloatingBar";
import { useSignupSession } from "../hooks/useSignupSession";

import { intl } from "./CheckoutBar.Intl";

interface CheckoutBarProps {
  disabled: boolean;
  onBeforeGoToCheckout: () => Promise<void>;
}

export const CheckoutBar = ({
  onBeforeGoToCheckout,
  disabled,
}: CheckoutBarProps) => {
  const [errors, setErrors] = useState<string[]>([]);
  const { updateSignupSession } = useSignupSession();

  const handleGoToCheckout = async () => {
    await onBeforeGoToCheckout();

    const url = new URL("/api/signup/callback", window.location.origin);

    const { redirectUri, errors } = await updateSignupSession({
      payment: {
        redirectUri: url.toString(),
      },
      cancellationUrl: window.location.href,
    }).unwrap();

    if (isNotEmptyArray(errors)) {
      setErrors(errors);
      return;
    }

    if (redirectUri) {
      window.location.href = redirectUri;
    }
  };

  return (
    <>
      <FloatingBar
        id="go-to-checkout-button"
        disabled={disabled}
        onContinue={handleGoToCheckout}
      />
      <Modal
        name="checkout-errors-modal"
        size="sm"
        open={isNotEmptyArray(errors)}
        onClose={() => setErrors([])}
        closeable={false}
      >
        <Card className="flex flex-col items-center gap-6 mt-28">
          <IconExclamationCircle className="w-20 h-20" />
          <p className="text-center">{intl.REQUIRED_INFORMATION_MISSING}</p>
          <Link href={BRAND_PATHS.SIGNUP_HREF}>
            <Button onClick={() => setErrors([])} primary>
              {intl.GO_BACK}
            </Button>
          </Link>
        </Card>
      </Modal>
    </>
  );
};
